import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";

import * as S from "./styles";
import Alert from "../../components/Alert";
import AnimationContainer from "../../components/AnimationContainer";
import LoginContainer from "../../components/LoginContainer";
import apiMagicLink from "../../services/apiMagicLink";
import LoginPageTitle from "../../components/LoginPageTitle";

const LoginMessage = () => {
  const history = useHistory();
  const location = useLocation();
  const props = location.state;
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({});

  useEffect(() => {
    if (!props || !props.email || !props.type) {
      history.push("/explore/entrar");
    }
  }, [props]);

  const messages = {
    login: {
      title: "Acessar por e-mail",
      subtitle: `O acesso à sua conta foi enviado para o seu e-mail (${props.email}) e expira em dez minutos.`,
    },
    password: {
      title: "Recuperar senha",
      subtitle: (
        <>
          As instruções para redefinir a sua senha foram enviadas para o seu
          e-mail:
          <br />
          <span className="text-white">{props.email}</span>
        </>
      ),
    },
  };

  const handleResend = async () => {
    setLoading(true);
    let recoverPassword = props.type === "password";

    try {
      await apiMagicLink.post("/signin", {
        email: props.email,
        pass: recoverPassword,
        appExplore: true,
      });

      setAlert({
        type: "success",
        message: "As instruções foram enviadas para o seu e-mail novamente.",
      });
    } catch {
      setAlert({
        type: "error",
        message:
          "Ocorreu um erro. Seu e-mail não foi reenviado. Tente novamente.",
      });
    }
    setLoading(false);
  };

  return (
    <LoginContainer>
      <S.LoginWrapper>
        <AnimationContainer show={!!alert.message}>
          <Alert variant={alert.type} text={alert.message} />
        </AnimationContainer>
        <LoginPageTitle
          title={messages[props.type].title}
          subtitle={messages[props.type].subtitle}
        />

        <div>
          <p>
            Se você não encontrou o e-mail na caixa de entrada, verifique a sua
            pasta de spam, a lixeira ou aguarde alguns minutos.
          </p>
          <S.SimpleButton onClick={handleResend} disabled={loading}>
            REENVIAR
            {loading && (
              <>
                &nbsp;
                <div className="spinner black" />
              </>
            )}
          </S.SimpleButton>
        </div>
      </S.LoginWrapper>
    </LoginContainer>
  );
};

export default LoginMessage;
